import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Pagination, Student } from "../../../types/lessonsStudents";
import { Group } from "features/model/types/groups/groupsSchema";

const initialState = {
    groupId: null,
    students: [] as Student[],
    pagination: {} as Pagination,
    isLoading: true,
    error: null,
};

const lessonsStudentsSlice = createSlice({
    name: "lessonsStudents",
    initialState,
    reducers: {
        setLessonsStudents: (state, action) => {
            const { items, pagination,groupId } = action.payload;
            state.students = items;
            state.groupId = groupId;
            state.pagination = pagination;
            state.isLoading = false;
            state.error = null;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const { setLessonsStudents, setLoading, setError } = lessonsStudentsSlice.actions;

export const lessonsStudentsReducer = lessonsStudentsSlice.reducer;


